/** @jsx jsx */
import { FC } from 'react';
import { jsx } from '@emotion/core';

import SimpleMessagePage from 'components/SimpleMessagePage';
import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';

const NonEmbeddedSuccess: FC = () => {
  const tMdMultiline = useMarkdownMultilineTranslate();

  return (
    <SimpleMessagePage
      headerTitle="unified.placeOrder.nonEmbeddedSuccess.title"
      message={tMdMultiline('unified.placeOrder.nonEmbeddedSuccess.message')}
    />
  );
};

export default NonEmbeddedSuccess;
